// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formatContainer_OSB9y {
  margin-top: 20px;
}
.formatContainer_OSB9y .format_rSr0u {
  margin: 25px 0 15px 0;
  font-size: 1.4em;
}
.pointer_gPM18 {
  cursor: pointer;
}
.button_xrbm5 {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid white;
  border-radius: 20%;
  padding: 10px;
  color: #7c7c7c;
  cursor: pointer;
  width: 100%;
  font-size: 20px;
}
.button_xrbm5:hover {
  color: white;
  background: #bbbaba;
}
.arrowContainer_wcGuD {
  display: flex;
  width: 20px;
  height: 20px;
  margin: 5px;
}
.dayItem_QWS6e {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
}
.menuItem_KKf0J {
  padding: 0 4px;
  margin: 5px 10px;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  border: none;
}
.menuItem_KKf0J .day_B8vpf {
  color: #94a3b8;
  font-size: 12px;
  font-weight: 400;
  line-height: 26px;
}
.menuItem_KKf0J .number_w2g7S {
  color: #1e293b;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
}
.menuItem_KKf0J.today_tAcRY .number_w2g7S {
  border-bottom: 2px solid #d19900;
}
.active_lqsw9 {
  border-radius: 20%;
  background-color: #f0f4fa;
}
.active_lqsw9 .number_w2g7S {
  color: #4997de;
}
.active_lqsw9 .day_B8vpf {
  color: #4997de;
}
.scroll-menu-arrow_WPdQk {
  padding: 10px;
  cursor: pointer;
}
.dot_ScwY6 {
  height: 25px;
  width: 25px;
  background-color: #f0f4fa;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Less/DatePickerSlider.less"],"names":[],"mappings":"AAOA;EACI,gBAAA;AANJ;AAKA;EAGQ,qBAAA;EACA,gBAAA;AALR;AASA;EACI,eAAA;AAPJ;AAUA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AATJ;AAWI;EACI,YAAA;EACA,mBAAA;AATR;AAaA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAXJ;AAcA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAZJ;AAeA;EACI,cAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,YAAA;AAbJ;AAQA;EAOQ,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAZR;AAEA;EAaQ,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAZR;AAeQ;EACI,gCAAA;AAbZ;AAkBA;EACI,kBAAA;EACA,yBAAA;AAhBJ;AAcA;EAKQ,cAAA;AAhBR;AAWA;EASQ,cAAA;AAjBR;AAqBA;EACI,aAAA;EACA,eAAA;AAnBJ;AAqBA;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AAnBJ","sourcesContent":["// *{\n// \tfont-family: sans-serif;\n// \tmargin: 0px;\n// \ttext-align: center;\n// \ttransition: 0.3 all ease;\n// }\n\n.formatContainer {\n    margin-top: 20px;\n    .format {\n        margin: 25px 0 15px 0;\n        font-size: 1.4em;\n    }\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n.button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    // background: #1d1d1d;\n    border: 1px solid white;\n    border-radius: 20%;\n    padding: 10px;\n    color: #7c7c7c;\n    cursor: pointer;\n    width: 100%;\n    font-size: 20px;\n\n    &:hover {\n        color: white;\n        background: #bbbaba;\n    }\n}\n\n.arrowContainer {\n    display: flex;\n    width: 20px;\n    height: 20px;\n    margin: 5px;\n}\n\n.dayItem {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n}\n\n.menuItem {\n    padding: 0 4px;\n    margin: 5px 10px;\n    user-select: none;\n    cursor: pointer;\n    border: none;\n    .day {\n        color: #94a3b8;\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 26px;\n    }\n    .number {\n        color: #1e293b;\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 26px;\n    }\n    &.today {\n        & .number {\n            border-bottom: 2px solid rgb(209, 153, 0);\n        }\n    }\n}\n\n.active {\n    border-radius: 20%;\n    background-color: #f0f4fa;\n\n    .number {\n        color: #4997de;\n    }\n\n    .day {\n        color: #4997de;\n    }\n}\n\n.scroll-menu-arrow {\n    padding: 10px;\n    cursor: pointer;\n}\n.dot {\n    height: 25px;\n    width: 25px;\n    background-color: #f0f4fa;\n    border-radius: 50%;\n    display: inline-block;\n    text-align: center;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formatContainer": `formatContainer_OSB9y`,
	"format": `format_rSr0u`,
	"pointer": `pointer_gPM18`,
	"button": `button_xrbm5`,
	"arrowContainer": `arrowContainer_wcGuD`,
	"dayItem": `dayItem_QWS6e`,
	"menuItem": `menuItem_KKf0J`,
	"day": `day_B8vpf`,
	"number": `number_w2g7S`,
	"today": `today_tAcRY`,
	"active": `active_lqsw9`,
	"scroll-menu-arrow": `scroll-menu-arrow_WPdQk`,
	"dot": `dot_ScwY6`
};
export default ___CSS_LOADER_EXPORT___;
